import React from 'react';
import { HeroBanner } from '../components/HeroBanner';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
export function ContactPage() {
  return <div className="flex flex-col w-full" data-id="element-252">
      <HeroBanner title="CONTACT US" subtitle="We're here to answer your questions and help protect your home." data-id="element-253" />

      <section className="py-20 px-4 bg-white" data-id="element-254">
        <div className="max-w-7xl mx-auto" data-id="element-255">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-256">
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 flex flex-col items-center text-center" data-id="element-257">
              <div className="w-12 h-12 bg-[#0c2340] rounded-full flex items-center justify-center mb-4" data-id="element-258">
                <Phone className="w-5 h-5 text-white" data-id="element-259" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-260">Phone</h3>
              <a href="tel:7146023634" className="text-[#b87333] hover:text-[#0c2340] transition-colors font-medium" data-id="element-261">
                (714) 602-3634
              </a>
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 flex flex-col items-center text-center" data-id="element-262">
              <div className="w-12 h-12 bg-[#0c2340] rounded-full flex items-center justify-center mb-4" data-id="element-263">
                <Mail className="w-5 h-5 text-white" data-id="element-264" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-265">Email</h3>
              <a href="mailto:info@aflowraingutters.com" className="text-[#b87333] hover:text-[#0c2340] transition-colors font-medium" data-id="element-266">
                info@aflowraingutters.com
              </a>
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 flex flex-col items-center text-center" data-id="element-267">
              <div className="w-12 h-12 bg-[#0c2340] rounded-full flex items-center justify-center mb-4" data-id="element-268">
                <MapPin className="w-5 h-5 text-white" data-id="element-269" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-270">Service Area</h3>
              <p className="text-slate-600" data-id="element-271">
                Orange County, CA &<br data-id="element-272" />
                Surrounding Areas
              </p>
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 flex flex-col items-center text-center" data-id="element-273">
              <div className="w-12 h-12 bg-[#0c2340] rounded-full flex items-center justify-center mb-4" data-id="element-274">
                <Clock className="w-5 h-5 text-white" data-id="element-275" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2" data-id="element-276">Hours</h3>
              <p className="text-slate-600" data-id="element-277">
                Mon-Fri: 8am - 5pm
                <br data-id="element-278" />
                Sat-Sun: Closed
              </p>
            </div>
          </div>

          <div className="max-w-3xl mx-auto bg-slate-50 rounded-2xl border border-slate-200 p-8 sm:p-10" data-id="element-279">
            <h2 className="text-2xl font-bold text-[#0c2340] mb-2 text-center" data-id="element-280">
              Send Us a Message
            </h2>
            <p className="text-slate-500 text-center mb-8" data-id="element-281">
              Have a general question? Fill out the form below.
            </p>

            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-282">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-283">
                <div className="space-y-2" data-id="element-284">
                  <label htmlFor="name" className="block text-sm font-medium text-slate-700" data-id="element-285">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="John Doe" data-id="element-286" />
                </div>
                <div className="space-y-2" data-id="element-287">
                  <label htmlFor="email" className="block text-sm font-medium text-slate-700" data-id="element-288">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="john@example.com" data-id="element-289" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-290">
                <label htmlFor="subject" className="block text-sm font-medium text-slate-700" data-id="element-291">
                  Subject
                </label>
                <input type="text" id="subject" className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow" placeholder="How can we help?" data-id="element-292" />
              </div>

              <div className="space-y-2" data-id="element-293">
                <label htmlFor="message" className="block text-sm font-medium text-slate-700" data-id="element-294">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#b87333] focus:border-[#b87333] outline-none transition-shadow resize-none" placeholder="Your message..." data-id="element-295"></textarea>
              </div>

              <button type="submit" className="w-full bg-[#b87333] hover:bg-[#a0632a] text-white font-bold py-4 px-8 rounded-lg transition-colors" data-id="element-296">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>;
}